import { render, staticRenderFns } from "./edit-photo.vue?vue&type=template&id=5b4d3d5a&scoped=true&"
import script from "./edit-photo.vue?vue&type=script&lang=js&"
export * from "./edit-photo.vue?vue&type=script&lang=js&"
import style0 from "./edit-photo.vue?vue&type=style&index=0&id=5b4d3d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4d3d5a",
  null
  
)

export default component.exports